// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledContentTypeFilter = styled('div')(
  () => css`
    .filter-content-type {
      &.MuiFormGroup-root {
        display: flex !important;
        margin-bottom: 12px;
      }
    }
  `
);
